import { jtDispatch, queryOne } from "../../utils";

export default class JTRadioSelect {
  $root;
  $input;
  name;

  constructor($root) {
    this.$root = queryOne($root);
    this.$input = this.$root.querySelector("input");
    this.name = this.$input.name;

    this.init = this.init.bind(this);
    this.toggleClass = this.toggleClass.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.init();
  }

  init() {
    window.addEventListener("change", this.handleChange);
    this.toggleClass();
  }

  destroy() {
    window.removeEventListener("change", this.handleChange);
  }

  toggleClass() {
    if (this.$input.checked) {
      this.$root.classList.add("active");
      jtDispatch.call(this, "active:jt:radioselect");
    } else {
      this.$root.classList.remove("active");
      jtDispatch.call(this, "inactive:jt:radioselect");
    }
  }

  handleChange(event) {
    if (event.target === this.$input || event.target.name === this.name) {
      this.toggleClass();
    }
  }
}
